import { useTranslation } from "react-i18next";
import { Control } from "react-hook-form";
import { FormGroup } from "@carbon/react";
import TextField from "../../../components/carbon/Form/TextField";
import PhoneField from "../../../components/carbon/Form/PhoneField";
import { RegisterFormValues } from "../types";

export interface PersonalInfoSectionProps {
  control: Control<RegisterFormValues>;
}

/**
 * Personal-information field group: firstName / lastName / email / confirmEmail / phone.
 * `phone` is the shared `PhoneField` (dial-code `Select` + digits `TextInput` bound to a
 * single RHF string), replacing the pre-Carbon custom `PhoneInput` + its inline `Controller`
 * and the separate `phoneValue` local state that shadowed RHF's own value.
 */
const PersonalInfoSection = ({ control }: PersonalInfoSectionProps) => {
  const { t } = useTranslation();

  return (
    <FormGroup legendText={t("register.form.userData")}>
      <div className="register__grid">
        <TextField
          name="firstName"
          label={t("register.form.firstName")}
          control={control}
          required
        />
        <TextField
          name="lastName"
          label={t("register.form.lastName")}
          control={control}
          required
        />
        <TextField
          name="email"
          type="email"
          label={t("register.form.email")}
          control={control}
          required
        />
        <TextField
          name="confirmEmail"
          type="email"
          label={t("register.form.confirmEmail")}
          control={control}
          required
        />
      </div>
      <PhoneField
        name="phone"
        label={t("register.form.phone")}
        countryCodeLabel={t("register.form.phone")}
        control={control}
        required
      />
    </FormGroup>
  );
};

export default PersonalInfoSection;
